<template>
  <div style="display: flex;text-align: center" :style="{height:height+'px',lineHeight:height+'px'}">
    <div style="flex: 2;" :style="{padding:option.attribute.icon.padding+'px'}">
      <div style="width: 100%;height: 100%;background-size: 100% 100%"
           :style="{backgroundImage:'url('+(option.attribute.icon.url ? (fileUrl + option.attribute.icon.url):require('@/assets/custom/iconRing/info.png'))+')'}"/>
    </div>
    <div style="flex: 4" class="title-1" :style="{color:option.attribute.title.color,fontSize:option.attribute.title.fontSize+'px',fontWeight:option.attribute.title.fontWeight}">
      {{option.attribute.title.text}}
    </div>
    <div style="flex: 3" class="title-2" :style="{color:option.attribute.num.color,fontSize:option.attribute.num.fontSize+'px',fontFamily:option.attribute.num.fontFamily}">
      <span :style="{fontWeight: option.attribute.num.fontWeight}">{{cptData.value}} </span>
      <span :style="{fontSize:(option.attribute.num.fontSize-4)+'px'}"> {{option.attribute.num.unit}}</span>
    </div>
    <div style="flex: 3;" class="title-3" v-if="option.attribute.grow.show">
      <span style="color: var(--td-gray-color-5);font-size: 12px">{{option.attribute.grow.label}} </span>
      <span :style="{color:option.attribute.grow.color,fontSize:option.attribute.grow.fontSize+'px',fontFamily:option.attribute.grow.fontFamily}">
        {{cptData.growth ? ((cptData.growth * 100).toFixed(2) + '%') : '0%'}}
      </span>
    </div>
    <div style="flex: 1;" v-if="option.attribute.grow.show" :style="{color:cptData.growth > 0 ? '#5daf34':'#c70707'}">{{cptData.growth > 0 ? '▲':'▼'}}</div>
  </div>
</template>

<script>
import {fileUrl} from "/env";
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-indicator",
  props:['option','height','components','current'],
  data(){
    return {
      fileUrl:fileUrl,
      cptData: {},
      uuid: null,
      newData:"",
      jsFunFlag:false,
    }
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    'option.attribute': {
      handler(obj) {
         this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods:{
    refreshCptData(cptDataForm = this.option.cptDataForm,paras){
      pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras){
      const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm,that.newData,that.jsFunFlag);
        // this.cptData = res;
      })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
      // 第一层判断 如果选择数据集
      if(cptDataForm.dataSource == '4') {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        if(jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
            if(hasNonEmptyValues(this.option.attribute.cptTableData)) {  
              const dataKey = this.option.attribute.cptTableData;
              // 创建一个新的数组用于存储结果
              let newres = [];
              let newObj = {...res[0]};
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
              dataKey.forEach(item => {
                newObj[item.namekey] = newObj[item.value];
              });
              newres.push(newObj);
              console.log(newres,'新数组')
              this.cptData = newres[0];
           }
          } else { // 如果配置了转换脚本
            this.cptData = res;
          }
      } else { // 不是数据集类型，是静态数据
           this.cptData = res;
        } 
    },
  }
}
</script>

<style scoped>
.title-1 {
  
}
</style>